module.exports = __webpack_public_path__ + "img/pro-photo11.4d43a628.png";